import { gql } from '@apollo/client';

export const GET_COMPANY_PROFILE_AND_REVIEW_SUMMARY_QUERY = gql`
  query GetCompanyDetailAndReviewSummary(
    $companyDetailsId: CompanyId!
    $draft: Boolean
    $locale: Locale
  ) {
    companyDetails(id: $companyDetailsId) {
      companyProfile(draft: $draft) {
        zone
        companyReviewRating {
          company {
            rating
            percentage
            count
          }
          perksAndBenefits {
            rating
            percentage
            count
          }
          careerOpportunity {
            rating
            percentage
            count
          }
          diversity {
            rating
            percentage
            count
          }
          executiveManagement {
            rating
            percentage
            count
          }
          workLifeBalance {
            rating
            percentage
            count
          }
          workEnvironment {
            rating
            percentage
            count
          }
          companyRating1Star {
            rating
            percentage
            count
          }
          companyRating2Star {
            rating
            percentage
            count
          }
          companyRating3Star {
            rating
            percentage
            count
          }
          companyRating4Star {
            rating
            percentage
            count
          }
          companyRating5Star {
            rating
            percentage
            count
          }
          companyRecommended {
            rating
            percentage
            count
          }
          salaryPoor {
            rating
            percentage
            count
          }
          salaryFair {
            rating
            percentage
            count
          }
          salaryGenerous {
            rating
            percentage
            count
          }
        }
        data {
          name
          overview {
            website {
              url
              displayName
            }
            size
            industry
            primaryLocation
            specialities
            description
            traditionalLand
            traditionalPlace
          }
          customStatement {
            title
            description
          }
          missionStatement
          featured {
            title
            description
            imageUrl
            videoUrl
          }
          awards {
            imageUrl
            year
            name
          }
          cultureAndValues {
            title
            description
            imageUrl
            values {
              title
              description
            }
          }
          perksAndBenefits {
            title
            description
          }
          gallery {
            title
            date
            linkUrl
          }
          branding {
            brandId
            logo
            cover
          }
          canonicalUrl
        }
        organisationId
      }
      id
      companyReviewsAISummary(locale: $locale) {
        reviewsCount
        reviewsDateFrom
        reviewsDateTo
        aISummaryContent {
          positiveAndChallengesSummary
        }
      }
    }
  }
`;
